import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Grid2 as Grid,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../../../Style/dialogStyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import { CHANGE_CLASS } from "../../../../Schema/Student";
import {
  SelectAcademicYear,
  SelectSchool,
  SelectClassByAcademicYearAndSchool,
} from "../../../../Function/DynamicSelect";

export default function StudentChangeClass({
  open,
  handleClose,
  setRefetch,
  editData,
  rowId,
  enrollmentTypeAction,
  rowDetail
}) {
  // console.log("editDataEnrollAction", editData);

  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  const [attendedClassId, setAttendedClassId] = useState({
    id: "",
    title: "",
  });

  useEffect(() => {
    if (enrollmentTypeAction === "student_page") {

      setAcademicYearVal({ id: rowDetail?.class_attended?.class_id?.academic_year_id?._id, title: rowDetail?.class_attended?.class_id?.academic_year_id?.academic_year })
      setSchoolVal({ id: rowDetail?.class_attended?.class_id?.school_id?._id, title: language === 'en' ? rowDetail?.class_attended?.class_id?.school_id?.school_name_en : rowDetail?.class_attended?.class_id?.school_id?.school_name })
    } else {

      setAcademicYearVal({ id: editData?.class_id?.academic_year_id?._id, title: editData?.class_id?.academic_year_id?.academic_year })
      setSchoolVal({ id: editData?.class_id?.school_id?._id, title: editData?.class_id?.school_id?.school_name_en })
    }
  }, [editData])

  //======================== change class =========================
  const [changeClass] = useMutation(CHANGE_CLASS, {
    onCompleted: ({ changeClass }) => {
      // console.log("changeClass::", changeClass);
      setLoading(false);
      if (changeClass?.is_success === true) {
        setAlert(true, "success", changeClass?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", changeClass?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    changeToClassId: Yup.string().required(t("require")),
  });

  const formik = useFormik({
    initialValues: {
      changeToClassId: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("va;ues",editData?._id,values?.changeToClassId)
      setLoading(true);
      changeClass({
        variables: {
          // id: editData?._id,
          id: enrollmentTypeAction === "student_page" ? rowId : editData?._id,
          changeToClassId: values?.changeToClassId,
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    setFieldValue("changeToClassId", attendedClassId?.id);
  }, [attendedClassId?.id]);

  useEffect(() => {
    resetForm();
    setAttendedClassId({ id: "", title: "" });

  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("dialog_title_update_enrollment")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("academic_year")}
                </Typography>
                <SelectAcademicYear
                  selectedVal={academicYearVal}
                  setSelectedVal={setAcademicYearVal}
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("school")}
                </Typography>
                <SelectSchool
                  selectedVal={schoolVal}
                  setSelectedVal={setSchoolVal}
                  disabled={academicYearVal?.id ? false : true}
                />
              </Grid> */}
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("class")}
                </Typography>
                <SelectClassByAcademicYearAndSchool
                  academicYearId={academicYearVal?.id}
                  schoolId={schoolVal?.id}
                  selectedVal={attendedClassId}
                  setSelectedVal={setAttendedClassId}
                  disabled={academicYearVal?.id && schoolVal?.id ? false : true}
                />
                {!!errors.changeToClassId && touched.changeToClassId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.changeToClassId}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            >
              {t("change_class")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
